import { performGetRequest } from '@atlassian/jira-fetch';

export const getPagesFeatureState = (
	projectId: string | number,
): Promise<{
	value: boolean;
}> =>
	performGetRequest(`/rest/api/2/project/${projectId}/properties/project-pages-link-enabled`).catch(
		(thrownError) => {
			/** If feature has never been set before 404 is returned. But default state of feature is enabled. */
			if (thrownError.statusCode === 404) {
				return Promise.resolve({ value: true });
			}
			return Promise.reject(thrownError);
		},
	);
